import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Input, Checkbox, Row, Col, Space, Tag } from 'antd';
import { debounce } from 'lodash';
import {Link, useNavigate} from 'react-router-dom';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {QueueRounded, TrafficRounded, ModelTrainingRounded, LightbulbRounded } from "@mui/icons-material";
import {useSelector} from "react-redux";
import {selectPortfoliosWithSignals} from "../../../../store/slices/portfolios.slice";
import { UserRoundCheck, UserSearch } from 'lucide-react';

const PortfoliosToolbar = ({ onFilter }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    b: false,
    s: true,
    m: true,
    mm: false,
  });


  // Debounced search to prevent excessive filtering while typing
  const debouncedSearch = useMemo(
    () => debounce((value) => onFilter({ searchTerm: value, filters }), 300),
    [filters, onFilter]
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
        setFilters((prevFilters) => {
            const updatedFilters = {...prevFilters, [name]: checked};
            onFilter({searchTerm, filters: updatedFilters});
            return updatedFilters;
        });

  };


  return (
    <Row gutter={[16, 16]} align={'middle'} justify={'space-between'} className={'my-3'}>
      <Col>
          <Row wrap={false} align={'middle'}>
              <Space direction={'vertical'}>
                  <Input
                        rootClassName={'primary mr-3'}
                        placeholder="Search portfolios by name"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        size={'large'}
                        style={{ width: '100%', minWidth: 300, maxWidth: 400}}
                    />
              </Space>
              <Col>
                  <Space wrap={true}>
                      <Checkbox className={'custom-checkbox mx-3 text-large text-1xl p-3'} name="m" checked={filters.m} onChange={handleCheckboxChange}>
                      Models
                    </Checkbox>
                    <Checkbox className={'custom-checkbox mx-3'} name="s" checked={filters.s} onChange={handleCheckboxChange}>
                      Sleeves
                    </Checkbox>
                    <Checkbox className={'custom-checkbox mx-3'} name="b" checked={filters.b} onChange={handleCheckboxChange}>
                      Blocks
                    </Checkbox>
                      <Checkbox className={'custom-checkbox mx-3'} name="mm" checked={filters.mm} onChange={handleCheckboxChange}>
                          <Space>
                              Client Models
                          </Space>
                    </Checkbox>
                      <Button endIcon={<UserSearch size={20}/>} onClick={()=>navigate('/portfolios/clients')}>
                          Search Clients
                      </Button>

                  </Space>
              </Col>
          </Row>
      </Col>
      <Col>
          <Row align={'middle'}>
              <Space>
                  <Button className={'pill'} size={'large'} variant={'contained'} color={'info'} startIcon={<LightbulbRounded/>} >
                      <Link to={'/beta/portfolios/views'}>
                          Cheatsheet
                      </Link>
                  </Button>
              </Space>
          </Row>
      </Col>
    </Row>
  );
};

export default PortfoliosToolbar;
